<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='微信通知管理' label2="新增微信通知" url="/system/notice/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">标题：</label>
            <div class="col-xl-6">
              <el-form-item prop="title" :rules="{required: true, message: '标题不能为空', trigger: 'blur'}">
                <el-input v-model="form.title" placeholder="请输入标题"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">内容：</label>
            <div class="col-xl-6">
              <el-form-item prop="content" :rules="{required: true, message: '内容不能为空', trigger: 'blur'}">
                <el-input v-model="form.content" :rows="5" placeholder="请输入内容"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">接收人：</label>
            <div class="col-xl-10">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                  row-key="UserID">
                  <el-table-column type="selection" width="55" :reserve-selection="true">
                  </el-table-column>
                  <el-table-column prop="TrueName" label="姓名">
                  </el-table-column>
                  <el-table-column prop="JobNum" label="工号">
                  </el-table-column>
                  <el-table-column prop="SecName" label="管理单元">
                  </el-table-column>
                  <el-table-column prop="RoleName" label="角色">
                  </el-table-column>
                </el-table>
                <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
                  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
                    :page-sizes="[5, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="condition.recordCount">
                  </el-pagination>
                </div>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoticeAdd',
    data() {
      return {
        condition: {
          token: '',
          pageSize: 5,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        form: {
          token: '',
          createuser: '',
          title: '',
          content: '',
          sendusers: [],
          noticetype: 1
        },
        tableData: [],
        fullscreenLoading: false,
        saveUrl: this.$utils.Url.zpgl + '/api/APINotice/Add',
        idKey: 'UserID'
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        // 改变页的时候调用一次
        this.condition.currentPage = val
        this.WeChatUserSearch()
      },
      // 分页操作
      handleSizeChange: function(val) {
        // 改变页的时候调用一次
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.WeChatUserSearch()
      },
      WeChatUserSearch: function(index) {
        if (index != null) {
          this.condition.currentPage = 1
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIZPGLUser/WeChatUser', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tableData = res.data.Data
              that.condition.recordCount = res.data.Pager.RecordCount
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.loading = false
          })
          .catch(err => {
            that.tableData = null
            that.condition.recordCount = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
            that.loading = false
          })
      },
      handleSelectionChange: function(val) {
        this.form.sendusers = val
      },
      Save: function() {
        console.log(this.form.sendusers)
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.sendusers.length == 0) {
              this.$message({
                message: '没有选择任何接收人',
                type: 'error'
              })
              return
            }
            this.fullscreenLoading = true
            this.$http.post(this.$utils.Url.zpgl + '/api/APINotice/Add', this.form)
              .then(res => {
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push('/main/system/notice/noticelist')
                } else {
                  this.$message({
                    message: res.data.Msg + '，' + res.data.Data,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.condition.token = sessionStorage.getItem('token')
      this.form.createuser = sessionStorage.getItem('userid')
      this.WeChatUserSearch()
    }
  }
</script>

<style>
</style>
